<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="form-page">
    <div class="form-page-header">
      <div class="form-page-header__icon"><i class="pi pi-pencil"></i></div>
      <div class="form-page-header__text">
        <h1 class="form-page-header__title">تعديل الكورس</h1>
        <p class="form-page-header__subtitle" v-if="course">{{ course.title }}</p>
      </div>
    </div>

    <Loading v-if="loading" />
    <div v-else-if="!course" class="ds-container">
      <div class="empty-state empty-state--card">
        <div class="empty-state__icon"><i class="pi pi-exclamation-triangle"></i></div>
        <h3 class="empty-state__title">لم يتم العثور على الكورس</h3>
        <p class="empty-state__desc">ربما تم حذف هذا الكورس مسبقاً.</p>
        <router-link to="/courses" class="ds-btn ds-btn--primary empty-state__action">رجوع للكورسات</router-link>
      </div>
    </div>
    <CourseForm v-else :course="course" />
  </div>
</template>

<script>
import Breadcrumb from '@/components/global/breadcrumb.vue';
import Loading from '@/components/global/loading.vue';
import CourseForm from './CourseForm.vue';
import { useCourseStore } from '@/stores/useCourseStore.js';

export default {
  name: 'CourseEdit',
  components: { Breadcrumb, Loading, CourseForm },
  data() {
    return {
      loading: true,
      course: null,
      breadcrumbs: [
        { name: 'الرئيسية', path: '/' },
        { name: 'الكورسات', path: '/courses' },
        { name: 'تعديل', path: '#' },
      ],
    };
  },
  async mounted() {
    try {
      this.course = await useCourseStore().fetchCourse(this.$route.params.id);
    } catch { this.course = null; } finally {
      this.loading = false;
    }
  },
};
</script>
